import axios from 'axios'

import { NewNumberModel, OperatorModel } from '../model/line.model'

export default class LineService {
  constructor(private host: string) {}

  fetchNewNumber(): Promise<NewNumberModel> {
    return axios
      .get(`${this.host}/sales/v1/masmovil/sales/lines/sign-ups/line-numbers`)
      .then((response) => response.data)
  }

  fetchOperatorDonor(phoneNumber: unknown): Promise<OperatorModel> {
    return axios
      .get(`${this.host}/sales/v1/masmovil/sales/lines/sign-ups/donor-operators/${phoneNumber}`)
      .then((response) => response.data)
  }

  fetchICCValidation(iccNumber: unknown, dealerName: string) {
    return axios
      .get(`${this.host}/sales/v1/masmovil/sales/lines/sign-ups/iccs/${iccNumber}/available`, {
        params: { dealerName },
      })
      .then((response) => response.data)
  }
}
